import React, { useEffect, useState } from 'react';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import MeridianLoader from '@amzn/meridian/loader';
import { useTranslation } from 'src/arb-wrapper';

export const DEFAULT_LOADER_DELAY = 1000;

interface LoaderProps {
  /**
   * Message to display while the loader is active. Defaults to "Loading...".
   */
  message?: string;

  /**
   * How long (in milliseconds) to wait before showing the spinner. Defaults to 1000
   */
  delay?: number;

  isLoading: boolean;
  children: React.ReactNode;
}

export const Loader: React.FC<LoaderProps> = (props) => {
  const { t } = useTranslation();
  const {
    delay = DEFAULT_LOADER_DELAY,
    message = t('loader_loading'),
    isLoading,
    children,
  } = props;
  const [isLongWait, setIsLongWait] = useState(false);

  useEffect(() => {
    isLoading &&
      setTimeout(() => {
        setIsLongWait(true);
      }, delay);
  }, [delay, isLoading, setIsLongWait]);

  return (
    <>
      {isLoading && isLongWait && (
        <Row alignmentHorizontal="center" data-testid="loader">
          <Column>
            <Text>{message}</Text>
            <MeridianLoader />
          </Column>
        </Row>
      )}
      {!isLoading && children}
    </>
  );
};
